declare var daum: any;

export class DaumPostcode {

    static postcodeOpen(keyword?: string): Promise<any> {

        var width = 500; //팝업의 너비
        var height = 600; //팝업의 높이

        return new Promise<any>((resolve, reject) => {

            if (!daum) {
                reject('[daum] 모듈이 초기화 되지 않았습니다.');
            }

            new daum.Postcode({
                oncomplete: (data: any) => {
                    resolve(data);
                },
                onclose: function (state: any) {
                    if (state !== 'COMPLETE_CLOSE') {
                        resolve(undefined);
                    }
                }
            }).open({
                q: keyword,
                left: (window.screen.width / 2) - (width / 2),
                top: (window.screen.height / 2) - (height / 2)
            });
        })
    }

    static postcodeEmbed(el: any, opts: any): Promise<any> {

        return new Promise<any>((resolve, reject) => {

            if (!daum) {
                reject('[daum] 모듈이 초기화 되지 않았습니다.');
            }

            new daum.Postcode({
                oncomplete: (data: any) => {
                    resolve(data);
                },
                onclose: function (state: any) {
                    if (state !== 'COMPLETE_CLOSE') {
                        resolve(undefined);
                    }
                },
                width: '100%',
                height: '100%',
                // maxSuggestItems: 5,
                theme: {
                    searchBgColor: "#2D3847", //검색창 배경색
                    queryTextColor: "#FFFFFF" //검색창 글자색
                }
            }).embed(el, opts);
        })
    }

}